import api from '../client';

export async function login(email, password, rememberMe = false) {
  const body = new URLSearchParams();
  body.set('username', email);
  body.set('password', password);
  body.set('remember_me', rememberMe ? 'true' : 'false');

  const { data } = await api.post('/token', body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  return data;
}

export async function register(payload) {
  const { data } = await api.post('/users/', payload);
  return data;
}

export async function fetchCurrentUser() {
  const { data } = await api.get('/users/me');
  return data;
}
